import { CLIENT_ID } from "@api/client-id";
import { runtimeConfig } from "@src/runtime-config";
import { CoreApiClient } from "@stellar/core-api-client";
import { sentryCaptureError } from "@utils/sentry-utils";

/**
 * This is the new Core API client that is used to communicate with the Core API repo.
 * It is used to fetch data from the Core API and to send data to the Core API.
 */
export const faroCoreApiClient = new CoreApiClient({
  baseUrl: runtimeConfig.urls.apiBaseUrl,
  procoreApiBaseUrl: runtimeConfig.integrations.procoreApiUrl,
  autodeskApiBaseUrl: runtimeConfig.integrations.autodeskApiUrl,
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "X-Holobuilder-Component": CLIENT_ID
  },
  // If the return type is different than what we expected, we log an assertion error.
  onLogAssertion: ({
    message,
    error,
    routeName
  }) => {
    const title = `CoreApiClient assertion error in route ${routeName}.`;

    // Capture the error with Sentry. The title has the route name making it easy to find.
    // The error shows the message from Zod as it is human readable
    sentryCaptureError({
      title,
      error: message,
      isAssertionError: true
    });

    // eslint-disable-next-line no-console
    console.error(title, message, error.issues);
  }
});